export default "__VITE_ASSET__DFIHCxPH__"